import { ArrayCheckboxesModule } from 'src/app/components/array-checkboxes/array-checkboxes.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MultiCheckInputComponent } from './multi-check-input.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatChipsModule } from '@angular/material/chips';
import { MatFormFieldWrapperModule } from 'src/app/mat-form-field-wrapper/mat-form-field-wrapper.module';
import { MatIconModule } from '@angular/material/icon';
import { FormsModule } from '@angular/forms';


@NgModule({
  declarations: [
    MultiCheckInputComponent
  ],
  imports: [
    CommonModule,
    ArrayCheckboxesModule,
    MatFormFieldModule,
    MatChipsModule,
    MatFormFieldWrapperModule,
    MatIconModule,
    FormsModule,
  ],
  exports: [MultiCheckInputComponent]
})
export class MultiCheckInputModule { }
